import { createSelector } from 'reselect';

const selectDSAPAgencies= (state: any) => state.dsapAgencies;


export const selectDSAPAgenciesCurrentItem = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.current);

export const selectDSAPAgenciesListItems = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.list);

export const selectDSAPAgenciesItemById = (itemId: any) =>
    createSelector(selectDSAPAgenciesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDSAPAgenciesQueryItems = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.query);

export const selectDSAPAgenciesCreatedItem = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.create);

export const selectDSAPAgenciesUpdatedItem = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.update);

export const selectReadItem = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.read);

export const selectDSAPAgenciesDeletedItem = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.delete);

export const selectDSAPAgenciesearchedItems = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.search);

export const selectDSAPAgenciesItemsCount = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.count);

export const selectDSAPAgenciesItemsFilter = createSelector([selectDSAPAgencies], (dsapAgencies) => dsapAgencies.filter);